export enum ProbateSections {
  HOME = 'HOME',
  SUBSCRIBER = 'SUBSCRIBER',
  DECEDENT = 'DECEDENT',
  WILL = 'WILL',
  HEIRS = 'HEIRS',
  DOCUMENTS = 'DOCUMENTS',
  ESTATE = 'ESTATE',
  FORMS = 'FORMS',
  TAXES = 'TAXES',
  BOND_SURETY = 'BOND_SURETY',
  NOTES = 'NOTES',
  MESSAGES = 'MESSAGES',
}

export enum ProbateSectionsAction {
  HELP = 'HELP',
}
